import React from "react";
import styles from "./ev-charger-gauge.module.scss";

interface IProps {
  children?: React.ReactNode;
  className?: string;
  ringColor?: string;
  isWavy?: boolean;
  innerColor?: string;
}

const EvChargerGauge = ({
  children,
  className = "",
  ringColor = "#49d5b9",
  isWavy = true,
  innerColor = "bg-white",
}: IProps) => {
  return (
    <div
      className={`${styles.gaugeContainer} d-flex justify-content-center align-items-center ${className}`}
    >
      <div
        className={isWavy ? styles.outerWavyRing : styles.outerStaticRing}
        style={ringColor ? { backgroundColor: ringColor } : undefined}
      ></div>
      <div className={`${styles.innerCircle} ${innerColor}`}></div>
      <div className={styles.gaugeContent}>{children}</div>
    </div>
  );
};

export default EvChargerGauge;
